import './styles.scss';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Typography, Box, Paper } from '@mui/material';

function Admin() {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ username: '', password: '' });
    const [message, setMessage] = useState('');

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));
    };

    const handleSubmit = async(e) => {
        e.preventDefault();

        const response = await fetch('https://livinghealthyme.com/server/login.php', {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                username: formData?.username,
               password: formData?.password
            }),
        });

        const result = await response.json();
        
        if (result.status === 'success') {
            navigate('/adminrecords')
        } else {
            setMessage('❌ Invalid username or password.');
        }
    };

    return (
        <div className="admin">
            <Box
                sx={{
                    width: 400,
                    margin: '100px auto',
                }}
            >
                <Paper elevation={3} sx={{ padding: 4 }}>
                    <Typography variant="h5" gutterBottom>
                    QBS KBC Health Forum
                    </Typography>

                    <form onSubmit={handleSubmit}>
                    <TextField
                        label="Username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <Button type="submit" variant="contained" fullWidth sx={{ mt: 2 }}>
                        Login
                    </Button>
                    </form>

                    {message && (
                    <Typography variant="body2" color="error" sx={{ mt: 2 }}>
                        {message}
                    </Typography>
                    )}
                </Paper>
            </Box>
        </div>
    );
}

export default Admin;
